export const INTEGRATION_TYPES = {
	FILTER: 'filter',
	SEARCH: 'search',
} as const;
